export default __webpack_public_path__ + "static/media/scrollUp.svg";